export enum DISPLAY_RANGE_MAP {
  QUE_OPTIONS = 1,
  QUE_ALL = 2,
}